/* eslint-disable no-underscore-dangle */
import {createReducer, on} from '@ngrx/store';
import * as saveSubscriptionOutOfStockActions from '../actions/subscription-out-of-stock.action';

export interface StateInit {
  item: any;
  items: any[];
  show: boolean;
}

export const initialState: StateInit = {
  item: '',
  items: [],
  show: false,
};

export const _subscriptionOutOfStockReducer = createReducer(
  initialState,
  on(saveSubscriptionOutOfStockActions.saveSubscriptionOutOfStock, (state, {item}) => ({
    ...state,
    item,
    items: [...state.items, item],
  })),
  on(saveSubscriptionOutOfStockActions.saveSubscriptionOutOfStockBraze, (state, {items}) => ({
    ...state,
    item: '',
    items: [...items],
  })),
  on(saveSubscriptionOutOfStockActions.modalSubscriptionOutOfStockBraze, (state, {show}) => ({
    ...state,
    show,
  })),
  on(saveSubscriptionOutOfStockActions.removeSubscriptionOutOfStock, (state, {item}) => ({
    ...state,
    items: state.items.filter(existingItem => existingItem !== item),
  })),
);

export function subscriptionOutOfStockReducer(state, action) {
  return _subscriptionOutOfStockReducer(state, action);
}
